module.exports = __webpack_public_path__ + "img/Amanda.cef481a6.png";